const StaffTrajectory = () => import('./views/StaffTrajectory.vue')
export default [
    {
        path: '/project/:id/GCB2/StaffTrajectory',
        name: 'GCB2StaffTrajectory',
        component: StaffTrajectory,
    },
]